import React, { FC } from 'react'
import styles from 'styles/components/tab.module.scss'
import { useDispatch } from 'react-redux'
import { push } from 'connected-react-router'

type Props = {
  isSelected: boolean
  label: string
  onClick?: () => void
  url: string
}

const Tab: FC<Props> = (props) => {
  const { isSelected, label, onClick, url } = props
  const dispatch = useDispatch()

  const className = isSelected ? styles.tab_selected : styles.tab

  return (
    <button className={className} onClick={onClick ? () => onClick() : () => dispatch(push(url))}>
      {label}
    </button>
  )
}

export default Tab
